import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { fetchFactoryEvents, fetchFactoryEventFacets } from './api';

/**
 * `keepPreviousData` on purpose: paging through a day, or stepping to the
 * previous one, otherwise blanks the list and re-runs the entrance animation on
 * every click. Holding the old rows until the new ones arrive makes the day
 * navigator feel like it is moving through one list rather than reloading a page.
 *
 * No refetchInterval — history does not change while you are reading it, and a
 * poll would fight with paging.
 */
export function useFactoryEvents(params) {
  // `{ skip: true }` is how a caller says "not yet" — the entity timelines know
  // their job or order id one render late, and a query fired without it would
  // ask for the whole factory and then throw the answer away.
  const skip = Boolean(params?.skip);

  return useQuery({
    queryKey: ['factory-events', params],
    queryFn: () => fetchFactoryEvents(params),
    enabled: !skip,
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}

export function useFactoryEventFacets(params) {
  return useQuery({
    queryKey: ['factory-events', 'facets', params],
    queryFn: () => fetchFactoryEventFacets(params),
    placeholderData: keepPreviousData,
    staleTime: 60_000,
  });
}
